import { axios } from '@/utils/axios';

const getConfig = async (viewportWidth) => {
	try {
		const {
			data: { mobileView, noCameraOptionDisplay, useQrCode, docVSdkKey, showSlideShowAtSubmit }
		} = await axios.post(`${process.env.BASE_URL}api/Configuration/DocumentVerification`, {
			viewportWidth,
		});

		return { mobileView, noCameraOptionDisplay, useQrCode, docVSdkKey, showSlideShowAtSubmit};
	} catch (error) {
		throw error;
	}
};

const initializeDocumentVerification = async (applicationId, isMobileView) => {
	try {
		const {
			data: { docVTransactionToken, skippable, docVCompleted, url, idTypeIcon, idTypeName }
		} = await axios.post(`${process.env.BASE_URL}api/DocumentVerification/TransactionToken`, {
			applicationId,
			isMobileView
		});

		return {
			docVTransactionToken,
			skippable,
			docVCompleted,
			url,
			idTypeIcon,
			idTypeName
		};
	} catch (error) {
		throw error;
	}
};

const completeDocumentVerification = async (applicationId) => {
	try {
		const {
			data: { docVCompleted }
		} = await axios.post(`${process.env.BASE_URL}api/DocumentVerification/Complete`, {
			applicationId,
		});

		return docVCompleted;
	} catch (error) {
		throw error;
	}
}

const resumeApplicationAfterDocVAsync = async applicationToken => {
	try {
		const {
			data: { docVCompleted,
				applicationId,
				primaryApplicantId,
				coBorrowerApplicantId,
				loanApplicationId,
				hasCoBorrower,
				applicationFlowType,
				productTypeId,
				firstName,
				coBorrowerApplicantToken
			}
		} = await axios.post(`${process.env.BASE_URL}api/DocumentVerification/Resume`, {
			applicationToken,
		});

		return {
			docVCompleted,
			applicationId,
			primaryApplicantId,
			coBorrowerApplicantId,
			loanApplicationId,
			hasCoBorrower,
			applicationFlowType,
			productTypeId,
			firstName,
			coBorrowerApplicantToken
		};
	} catch (error) {
		throw error;
	}
};

export default {
	getConfig,
	initializeDocumentVerification,
	completeDocumentVerification,
	resumeApplicationAfterDocVAsync
};

export { getConfig, initializeDocumentVerification, completeDocumentVerification, resumeApplicationAfterDocVAsync };
